import React from 'react';
import { Typography } from '../../../../../../wag-react/components/Typography';
import { LI } from '../../../../../../wag-react/core-components/li';
import { UL } from '../../../../../../wag-react/core-components/ul';
import { CheckIcon } from '../../../../../../wag-react/next-components/icons';
const details = ['Visit your vet', 'Submit a request', 'Get reimbursed'];
export const PlanSummaryDetails = () => <UL listStyle="none" p={0} pl={2} data-sentry-element="UL" data-sentry-component="PlanSummaryDetails" data-sentry-source-file="index.tsx">
    {details.map(detail => <LI key={detail}>
        <Typography lineHeight="30px" fontSize={['18px', '24px']} m="6px">
          <CheckIcon color="wagGold" height="20px" mr={2} width="20px" />
          {detail}
        </Typography>
      </LI>)}
  </UL>;